module.exports = __webpack_public_path__ + "img/atlas-logo.f2f776b4.png";